module.exports = __webpack_public_path__ + "static/media/ste_2016_rimini_1.802896be.jpg";